import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import ReactSpinner from 'react16-spinjs';
import onClickOutside from 'react-onclickoutside';
import { SUCCESS_MODAL } from '../../components/Modal';
import { modifyDevice, createDevice } from '../../utils/deviceUtils';
import './ModifyModal.css';

const messages = defineMessages({
  modifyNameDescription: {
    id: 'modifyNameDescription',
    defaultMessage: 'Create a unique friendly name for your device'
  },
  thirtyDayDescription: {
    id: 'thirtyDayDescription',
    defaultMessage: 'Ask user for a code every 30 days'
  },
  everyTimeDescription: {
    id: 'everyTimeDescription',
    defaultMessage: 'Ask user for a code every time'
  },
  neverDescription: {
    id: 'neverDescription',
    defaultMessage: 'Never ask for a code'
  },
  modifyError: {
    id: 'modifyError',
    defaultMessage: 'Unable to modify device. Please try again.'
  }
});

const spinnerConfig = {
  lines: 13,
  length: 37,
  width: 19,
  radius: 47,
  color: '#413675',
  speed: 0.7
};

let isMounted;

class ModifyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      config: Object.assign({},
          { friendly_name: props.contact.description, code_policy: 0 },
          props.contact),
      modifyError: null,
      sendingCommand: false
    };
  }

  componentDidMount() {
    isMounted = true;
  }

  componentWillUnmount() {
    isMounted = false;
  }

  validateForm = () => (this.state.config.friendly_name &&
    ((this.state.config.friendly_name !== this.props.contact.description)));

  render() {
    const {
        contact,
        intl,
        setModal,
        updateContact,
        firstTime
    } = this.props;

    if (this.state.sendingCommand) {
      return (
        <div className="modifyModal">
          <ReactSpinner config={spinnerConfig} />
        </div>
      );
    }

    return (
      <div className="modifyModal">
        <h2 className="modifyTitle">
          {firstTime ?
            <FormattedMessage
              id="modifyCreateTitle"
              defaultMessage="Name your Lifesize Share device"
            />
          :
            <FormattedMessage
              id="modifyingTitle"
              defaultMessage="Modifying Device Settings for {deviceDescription}"
              values={{
                deviceDescription: <a href={contact.host} rel="noopener noreferrer" target="_blank">{contact.description}</a>
              }}
            />
          }
        </h2>
        <div className="inputGroup">
          <FormattedMessage
            className="modifyingLabel"
            id="modifyingLabel"
            defaultMessage="Enter name"
          />
          <input
            type="text"
            className="deviceNameInput"
            defaultValue={contact.description}
            placeholder={intl.formatMessage(messages.modifyNameDescription)}
            onChange={(evt) => {
              this.setState({
                config: Object.assign({},
                this.state.config,
                { friendly_name: evt.target.value, description: evt.target.value })
              });
            }}
          />
        </div>
        <div className="buttonBar">
          {this.state.modifyError && <div className="modifyError">{this.state.modifyError}</div>}
          <button
            className={`mainButton ${this.validateForm() ? '' : 'disabled'}`}
            disabled={!this.validateForm()}
            onClick={() => {
              this.setState({ sendingCommand: true, modifyError: null });
              const deviceCommand = firstTime ? createDevice : modifyDevice;

              deviceCommand(this.state.config).then((res) => {
                if (isMounted) {
                  this.props.history.push('/');
                  this.setState({ sendingCommand: false });
                  updateContact(res.result);
                  setModal(SUCCESS_MODAL, { result: res.result });
                }
              })
              .catch(() => {
                if (isMounted) {
                  this.setState({
                    sendingCommand: false,
                    modifyError: intl.formatMessage(messages.modifyError)
                  });
                }
              });
            }}
          >
            <FormattedMessage
              id="saveButton"
              defaultMessage="Save"
            />
          </button>
          <button
            className="mainButton secondaryButton"
            onClick={() => {
              setModal(null);
            }}
          >
            <FormattedMessage
              id="cancelButton"
              defaultMessage="Cancel"
            />
          </button>
        </div>
      </div>
    );
  }
}

ModifyModal.propTypes = {
  contact: PT.object,
  intl: PT.object,
  setModal: PT.func,
  updateContact: PT.func,
  firstTime: PT.bool,
  history: PT.object
};

export default withRouter(injectIntl(onClickOutside(ModifyModal)));



// WEBPACK FOOTER //
// ./src/components/ModifyModal/ModifyModal.js